module.exports = __webpack_public_path__ + "img/fromages.ac12b446.png";